// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pla-root {
  width: 100%;
  background: #fff;
}

.pla-content {
  display: grid;
  grid-template-columns: calc(55% - 28px) 45%;
  column-gap: 24px;
  row-gap: 28px;
  margin-top: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/paymentLinkAnalytics/paymentLinkAnalytics.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".pla-root {\n  width: 100%;\n  background: #fff;\n}\n\n.pla-content {\n  display: grid;\n  grid-template-columns: calc(55% - 28px) 45%;\n  column-gap: 24px;\n  row-gap: 28px;\n  margin-top: 28px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
